
export default {
  props: {
    color: {
      default: "green darken-2",
      type: String
    },
    backgroundColor: {
      default: "black",
      type: String
    }
  }
};
